/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getSeasonsRanking = function () 
{
    const endpoint = `/rankingSeasons`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 
 



// WEBPACK FOOTER //
// ./src/components/pages/api/getSeasonsRanking.js